/**
 * システム全体で使用する定数
 */

// 連絡先メールアドレス（ローカライズ対象外）
export const CONTACT_EMAIL = "global.ops.hq@gmail.com";

// 連絡先の名前（日本語）
export const CONTACT_NAME_JA = "下村一将";

// 連絡先の名前（英語）
export const CONTACT_NAME_EN = "Kazumasa Shimomura";
